import React, { useCallback, useEffect } from 'react';

import { Button } from '@change/ds-core-ui';

import { Translate } from '@change-corgi/core/react/i18n';

import { useCampaignTracking } from 'src/app/shared/hooks/campaignTracking';

export const ViewPetitionFeed: React.FC<ViewPetitionFeedProps> = ({ petitionId, slug }) => {
	const { track } = useCampaignTracking();

	const trackViewAllClick = useCallback(() => {
		track('campaign_action_supporter_voices_view_all_click', { petition_id: petitionId });
	}, [petitionId, track]);

	useEffect(() => {
		track('campaign_action_supporter_voices_view_all_view', { petition_id: petitionId });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<div className="flex justify-center">
			<Button
				as="a"
				className="w-full md:w-auto"
				data-testid="supporter-voices-view-all"
				data-qa="supporter-voices-view-all"
				href={`/p/${slug}/feed`}
				variant="secondary"
				onClick={trackViewAllClick}
			>
				<Translate value="corgi.petition_gamma.videos.view_all" />
			</Button>
		</div>
	);
};

type ViewPetitionFeedProps = {
	petitionId: string;
	slug: string;
};
